/// <amd-module name="TFS/Admin/Views/ProfileSettings/OrganizationsView/Components/OrganizationsTableView" />
import React = require("react");

import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { ITableColumn, SimpleTableCell, Table, TableColumnStyle, ColumnJustification } from "VSSUI/Table";
import { Card } from "VSSUI/Card";
import { Button } from "VSSUI/Button";
import { Tooltip } from "VSSUI/TooltipEx";
import { localeFormat } from "VSS/Core/Util/String";
import { IObservableValue, ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { Organization } from "TFS/Admin/Views/ProfileSettings/OrganizationsView/Contracts";
import * as Resources from "TFS/Admin/Views/ProfileSettings/OrganizationsView/Resources";

interface IOrganizationsTableViewProps {
    organizations: ObservableArray<Organization>;
    onButtonClicked: (organization: Organization) => void;
    deletedOrgs?: boolean;
}

export default class OrganizationsTableView extends VssComponent<IOrganizationsTableViewProps> {
    public render() {
        return (
            <Card
                titleProps={{ text: this.props.deletedOrgs ? Resources.DeletedTitle: Resources.MyTitle }}
                className="org-card"
                contentProps={{ contentPadding: false }}
            >
                <Table
                    itemProvider={this.props.organizations}
                    columns={this.getColumnItems()}
                    singleClickActivation={true}
                />
            </Card>
        );
    }

    private getColumnItems(): ITableColumn<Organization>[] {
        return [
            {
                id: "name",
                name: Resources.Name,
                renderCell: (row, col, tcol, item) =>
                    this.renderTextCell(row, col, tcol, item.name),
                width: new ObservableValue(-30),
                columnStyle: TableColumnStyle.Primary,
                onSize: this.onSizeColumn
            },
            {
                id: "last-access",
                name: Resources.LastAccess,
                renderCell: this.renderDateCell,
                width: new ObservableValue(-30),
                columnStyle: TableColumnStyle.Secondary,
                onSize: this.onSizeColumn
            },
            {
                id: "description",
                name: Resources.Description,
                renderCell: (row, col, tcol, item) => this.renderTextCell(row, col, tcol, item.description),
                width: new ObservableValue(-10),
                columnStyle: TableColumnStyle.Secondary,
                onSize: this.onSizeColumn
            },
            {
                id: "action",
                name: "",
                renderCell: this.renderActionCell,
                width: 150,
                columnStyle: TableColumnStyle.Secondary,
                justification: ColumnJustification.Right
            }
        ];
    }

    private onSizeColumn(event: MouseEvent, index: number, width: number, column: ITableColumn<Organization>) {
        (column.width as IObservableValue<number>).value = width;
    }

    private renderTextCell(
        rowIndex: number,
        columnIndex: number,
        tableColumn: ITableColumn<Organization>,
        text: string
    ): JSX.Element {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={columnIndex}>
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis">{text}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private renderDateCell(
        rowIndex: number,
        columnIndex: number,
        tableColumn: ITableColumn<Organization>,
        item: Organization
    ): JSX.Element {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={columnIndex} contentClassName="display-ssh-date-added-details">
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis">{localeFormat("{0}", item.lastUserAccess)}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private renderActionCell = (
        rowIndex: number,
        columnIndex: number,
        tableColumn: ITableColumn<Organization>,
        item: Organization
    ): JSX.Element => {
        const { deletedOrgs } = this.props;
        const text = deletedOrgs ? Resources.Restore : Resources.Leave;
        const iconName = deletedOrgs ? "Undo" : "Remove";
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={columnIndex} className={"bolt-table-cell-side-action"}>
                <Button
                    text={text}
                    iconProps={{ iconName }}
                    ariaLabel={text}
                    onClick= {() => this.props.onButtonClicked(item)}
                    tooltipProps={{ text }}
                    disabled={!deletedOrgs == item.isOwner}
                />
            </SimpleTableCell>
        )
    }
}
